//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Http from "../utils/http";
import Action from "../action";
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      events: [],
      currentDate: new Date().toISOString().slice(0, 10)
    };
  },
  computed: {
    title: function title() {
      var months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
      var current = new Date(this.currentDate);
      return "".concat(months[current.getMonth()], " ").concat(current.getFullYear());
    }
  },
  methods: {
    next: function next() {
      this.$refs.calendar.next();
    },
    prev: function prev() {
      this.$refs.calendar.prev();
    },
    $ready: function $ready() {
      this.fetchData();
    },
    fetchData: function fetchData() {
      var _this = this;

      var url = new URL(this.spec.dataUrl);
      Http.execute({
        url: url.toString()
      }, "GET", this, function (response) {
        var events = response.rows; // this.currentDate = events[0].start;

        var beginningDate = true;
        _this.events = events.map(function (item) {
          item.name = item.title;
          var extra = item.extra;
          item.start = extra.start;
          item.end = extra.end;

          if (beginningDate) {
            beginningDate = false;
            _this.currentDate = item.start;
          }

          return item;
        });
      });
    },
    showEvent: function showEvent(_ref) {
      var event = _ref.event,
          target = _ref.target;
      Action.execute(event.onClick, this);
    }
  }
};